import { render, staticRenderFns } from "./BaseSingleSelectItem.vue?vue&type=template&id=67869783&scoped=true&"
import script from "./BaseSingleSelectItem.vue?vue&type=script&lang=js&"
export * from "./BaseSingleSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseSingleSelectItem.vue?vue&type=style&index=0&id=67869783&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67869783",
  null
  
)

export default component.exports